// src/components/WholesaleRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const WholesaleRoute = () => {
  const { user } = useAuth();

  // Check if user exists and has wholesale role
  if (!user) {
    return <Navigate to="/login" />;
  }

  // Check if user has wholesale role
  if (user.role !== 'wholesale') {
    return <Navigate to="/dashboard" />;
  }

  // If user is authenticated and has wholesale role, render the route
  return <Outlet />;
};

export default WholesaleRoute;